module.exports = __webpack_public_path__ + "img/bronze.9f0f5ced.png";